import {
  BoardGroupManagerModal,
  UserGroupManagerModal,
} from "@/components/GroupManagerModal";
import HBIcon from "@/components/HBIcon";
import { Dropdown, Menu } from "antd";
import classNames from "classnames";
import { useMemo, useRef } from "react";
import styles from "./operationButton.module.less";
export const followType = {
  independent: 0, //独立关注
  unIndependent: 1, //表示是因为关注用户而关注的
};
enum TYPE {
  grouping = "0", // 分组
}
enum GROUPTYPE {
  user,
  board,
}
interface IProps {
  [x: string]: any;
  userInfo?: any;
  boardInfo?: any;
  className?: string;
  onClick: () => void;
}
export default function OperationButton({
  onClick,
  userInfo,
  boardInfo,
  className,
  btnText = "已关注",
  ...props
}: IProps) {
  const buttonRef = useRef();
  const groupType = useMemo(() => {
    if (boardInfo) {
      return GROUPTYPE.board;
    } else if (userInfo) {
      return GROUPTYPE.user;
    }
  }, [userInfo, boardInfo]);
  const grouping = () => {
    if (groupType === GROUPTYPE.board) {
      BoardGroupManagerModal.open({
        board: boardInfo,
        onOk: () => {},
        okButtonProps: {
          "data-gd-click": "button_click",
          "data-button-name": "保存到分组_画板",
        },
      });
    } else {
      UserGroupManagerModal.open({
        user: userInfo,
        onOk: () => {},
        okButtonProps: {
          "data-gd-click": "button_click",
          "data-button-name": "保存到分组_用户",
        },
      });
    }
  };
  const fnMap = {
    [TYPE.grouping]: grouping,
  };

  const choose = (data) => {
    fnMap[data.key]();
  };

  return (
    <div ref={buttonRef} className={styles.warapper}>
      <Dropdown.Button
        onClick={onClick}
        className={classNames([styles.dropDownBtn, className])}
        overlayClassName={styles.dropdownOverlay}
        getPopupContainer={(triggerNode) => buttonRef.current}
        icon={
          <HBIcon
            type="ic_more"
            className={styles.dropDownIcon}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          />
        }
        {...props}
        overlay={
          <Menu onClick={choose}>
            <Menu.Item
              key={TYPE.grouping}
              data-gd-click="button_click"
              data-button-name={
                groupType === GROUPTYPE.user ? "设置分组_用户" : "设置分组_画板"
              }
            >
              设置分组
            </Menu.Item>
          </Menu>
        }
      >
        {btnText}
      </Dropdown.Button>
    </div>
  );
}
